module.exports = __webpack_public_path__ + "static/media/51.9a328693.png";